import React from "react";
import styled from "styled-components";
import { ContactIcon, ContactVector } from "../../shared/icons";
import SendMessageForm from "./SendMessageForm";

const Section = styled.div`
  background: #1e440b url(${ContactVector}) no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const ContentWrapper = styled.div`
  text-align: center;
  max-width: 600px;
  width: 100%;
  padding: 20px;
`;

const Heading = styled.h5`
  font-size: 36px;
  font-weight: 400;
  color: #ffffff;
  margin: 20px 0;
`;

const FormWrapper = styled.div`
  margin-top: 20px;
  text-align: left;
`;

const ContactSection = () => {
  return (
    <Section>
      <ContentWrapper>
        <ContactIcon />
        <Heading>Send Message</Heading>
        <FormWrapper>
          <SendMessageForm />
        </FormWrapper>
      </ContentWrapper>
    </Section>
  );
};

export default ContactSection;
